import * as Yup from "yup";

export const ValidationSchema = Yup.object().shape({
    chapter:Yup.string()
    .required('Affiliated Regional Chapter is required!')
    .nullable(),
});